//
// Theme responsive navbar
//

(function ($, waTheme) {

    var NavbarMobile = (function ($) {

        NavbarMobile = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$next = that.$wrapper.find(".nav-next");

            that.$offcanvas = that.$wrapper.find(".l-mobile-header__offcanvas");
            that.$canvas_logo = that.$wrapper.find(".l-mobile-header__nav-prev .b-mobile-logo");
            that.$canvas_prev = that.$wrapper.find(".b-mobile-nav-prev");

            that.$nav = that.$wrapper.find(".b-mobile-nav");

            // VARS
            that.exclude_categories = that.$nav.data("categories-exclude").toString();
            that.exclude_pages = that.$nav.data("pages-exclude").toString();

            // DYNAMIC VARS

            // INIT
            that.init();

            // EVENTS
            that.bindEvents();
        };

        NavbarMobile.prototype.init = function () {
            var that = this;

            if (that.exclude_categories !== "") {
                var exclude_array = that.exclude_categories.split(",");
                for (const excludeElement of exclude_array) {
                    var $el = that.$nav.find(`[data-category-id="${excludeElement}"]`);
                    if ($el.length) {
                        $el.parent().remove();
                    }
                }
            }

            if (that.exclude_pages !== "") {
                var exclude_array = that.exclude_pages.split(",");
                for (const excludeElement of exclude_array) {
                    var $el = that.$nav.find(`[data-pages-id="${excludeElement}"]`);
                    if ($el.length) {
                        $el.parent().remove();
                    }
                }
            }
        };

        NavbarMobile.prototype.bindEvents = function () {
            var that = this;

            // Показываем след. вложенное меню
            that.$next.on("click", function () {
                var $dropdown = $(this).parents(".nav-item").children(".dropdown-menu");

                $dropdown.addClass("showing");
                setTimeout(function () {
                    $dropdown.removeClass("showing");
                    $dropdown.addClass("show");
                }, 1);

                that.$canvas_logo.addClass("is-hidden");
                that.$canvas_prev.removeClass("is-hidden");

            });

            // Показываем пред. меню
            that.$canvas_prev.on("click", function () {
                var $active = that.$wrapper.find(".dropdown-menu.show").last();
                $active.removeClass("show");

                if (that.$wrapper.find(".dropdown-menu.show").length === 0) {
                    that.$canvas_logo.removeClass("is-hidden");
                    that.$canvas_prev.addClass("is-hidden");
                }
            });

            // Custom opener
            $(".js-mobile-catalog-toggle").on("click", function () {
                that.$offcanvas.offcanvas("toggle");
            });

        };

        return NavbarMobile;

    })($);

    waTheme.init.site.NavbarMobile = NavbarMobile;

    var $wrapper = $(".l-mobile-header");
    if ($wrapper.length) {
        $wrapper.each(function () {
            waTheme.apps["site"].NavbarMobile = new window.waTheme.init.site.NavbarMobile({
                $wrapper: $(this),
            });
        });
    }

})(jQuery, window.waTheme);
